import React, { useState, useEffect } from 'react'
import Select, { components } from 'react-select'
import { CheckBox } from './styled'
import { Button } from '../common/Button'
import { MagnifyingGlass } from '@phosphor-icons/react'

// Componente personalizado para renderizar opções como checkboxes
const CheckboxOption = (props) => {
  // Verifica se a opção é "Select All" e não renderiza checkbox para ela
  if (props.data.value === '*') {
    return <components.Option {...props} />
  }

  return (
    <CheckBox
      style={{
        border: '1px solid #CECECE',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
      }}
      onClick={() => props.selectOption(props.data)}
    >
      <div className="container">
        <input
          type="checkbox"
          {...props.innerProps}
          checked={props.isSelected}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
          style={{ margin: '0 8px 0 0' }}
        />
        <span className="checkmark"></span>
        <span>{props.label}</span>
      </div>
    </CheckBox>
  )
}

export function MultiSelect({
  selectedOptionsProp,
  onChangeProp,
  options,
  placeholder,
}) {
  const [selectedOptions, setSelectedOptions] = useState(
    selectedOptionsProp || [],
  )
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  useEffect(() => {
    setSelectedOptions(selectedOptionsProp || [])
  }, [selectedOptionsProp])

  const isSelectAllSelected = selectedOptions.some(
    (option) => option.value === '*',
  )

  const handleChange = (selected) => {
    if (selected && selected.some((option) => option.value === '*')) {
      setSelectedOptions(options.filter((option) => option.value !== '*'))
    } else {
      setSelectedOptions(selected)
    }

    if (onChangeProp) {
      onChangeProp(selected)
    }
  }

  const getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {
    if (value && value.some((o) => o.value === '*')) {
      return `${placeholderButtonLabel}: All`
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`
    }
  }

  const extendedOptions = [
    { value: '*', label: 'Selecionar todos' },
    ...options,
  ]

  const CustomMenu = (props) => {
    const { children, innerRef, innerProps } = props
    return (
      <div ref={innerRef} {...innerProps}>
        {children}
        <Button.Root
          backgroundColor="#00517D"
          type="button"
          onClick={() => setMenuIsOpen(false)}
        >
          <Button.Content title="Confirmar" color="#fff" />
        </Button.Root>
      </div>
    )
  }

  const SearchIcon = () => {
    return (
      <>
        <MagnifyingGlass size={22} />
      </>
    )
  }

  return (
    <div>
      <Select
        options={extendedOptions}
        value={selectedOptions}
        onChange={handleChange}
        getDropdownButtonLabel={getDropdownButtonLabel}
        placeholder={placeholder}
        noOptionsMessage={() => 'Nenhuma opção encontrada'}
        isMulti
        styles={{
          multiValueContainer: () => ({
            maxHeight: '10rem', // altura máxima desejada
            overflow: 'auto', // adicionar scroll quando necessário
          }),
          valueContainer: () => ({
            display: 'flex',
            padding: '10px',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignItems: 'center',
            maxHeight: '10rem',
            overflow: 'auto', // adicionar scroll quando necessário
          }),
          indicatorsContainer: () => ({
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }),
        }}
        components={{
          Option: CheckboxOption,
          Control: (props) => (
            <components.Control {...props}>
              {props.children}
              <div
                style={{
                  padding: '10px',
                }}
              >
                <SearchIcon />
              </div>
              {/* Ícone de pesquisa */}
            </components.Control>
          ),
          Menu: CustomMenu,
        }}
        hideSelectedOptions={false}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        maxMenuHeight={200}
        minMenuHeight={200}
        cropWithEllipsis={false}
        blurInputOnSelect
        tabSelectsValue={false}
      />
      {isSelectAllSelected && <p>Todas as opções foram selecionadas!</p>}
    </div>
  )
}
